export enum CentsPalette {
  cents_purple = '#7307F7',
  cents_purple_light = '#7307F7B3',
  cents_purple_lighter = '#7307F70D',
  cents_black = '#141010',
  cents_white = '#FFFFFF',
  cents_grey = '#F5F5FA',
  cents_orange = '#FF8E68',
};
